// src/views/Legal/TermsOfService.js
import React from "react";

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">
        Términos de Servicio
      </h1>

      <p className="mb-4">
        Bienvenido a nuestro sitio web y servicios digitales. Al acceder o
        utilizar nuestras plataformas, aceptas cumplir con estos Términos de
        Servicio. Si no estás de acuerdo con ellos, no utilices nuestros
        servicios.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Uso del Servicio</h2>
      <p className="mb-4">
        Nuestros productos y herramientas están destinados para uso comercial y
        profesional. No podrás utilizarlos para actividades ilegales o no
        autorizadas.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Propiedad Intelectual
      </h2>
      <p className="mb-4">
        Todo el contenido, diseño, logotipos y software son propiedad de la
        empresa y están protegidos por derechos de autor y propiedad
        intelectual.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Limitación de Responsabilidad</h2>
      <p className="mb-4">
        No somos responsables de daños directos o indirectos derivados del uso
        de nuestras plataformas o de servicios de terceros conectados.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Modificaciones</h2>
      <p className="mb-4">
        Podemos actualizar estos términos en cualquier momento. Las
        modificaciones serán publicadas en esta misma página con fecha de
        actualización.
      </p>

      <p className="text-sm text-gray-500 mt-8">
        Última actualización: {new Date().toLocaleDateString("es-PR")}
      </p>
    </div>
  );
};

export default TermsOfService;
